import React from 'react';
import Radium from 'radium';

import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm, TextArea, ComboBox} from 'views/FormElements';
import {AddedImagePreview, ImgUploadForm} from 'views/designer/SubmitProductForm';
import HttpService from 'service/HttpService';

import SelectedImagePreview from 'views/product/SelectedImagePreview';

import AppConstants from 'AppConstants';
import {Separator, A} from 'views/AppElements';
import AppUtil from '../../AppUtil';

const PRODUCT_IMAGES_LMT = 2;
const DIGITAL_ART_IMG_CONSTRAINT = "At least 600px x 600px, Max 50-200 Kb";
const PHOTOGRAPH_IMG_CONSTRAINT = "At least 800px in height or width, Max 50-200 Kb";

const ARTWORK_TYPES = AppConstants.ARTWORK_TYPES;
const PRODUCT_TYPES = AppConstants.PRODUCT_TYPES;


const StepOne = ({values, baseProduct}) => {
	const baseProductType = baseProduct.productType;
	const artworkType = ARTWORK_TYPES[values.artworkType];
	const productTypeOptions = Object.keys(PRODUCT_TYPES)
										.map(k => PRODUCT_TYPES[k])
										.filter(p => p.available === true)
										.filter(p => {
											return p.val !== baseProductType && artworkType.supportedProductTypes.indexOf(p.val) >= 0;
										})
										.map(function(p){
													return {'label': p.label, 
															'value': p.val}
												});

	const productType = PRODUCT_TYPES[values.productType];
	
	return <div>
		<div className="submitStep flexRow">
			<span>Step</span> <span className="stepCount">1</span>
		</div>

		<div className="flexColumn">
			<label style={{margin: '0 0 10px 0', display: 'block'}}>Select Product Type:</label>
			<ComboBox name="productType" value={values.productType} 
										options={productTypeOptions} 
										style={{flexGrow: '1', minWidth: '50%'}} />
			
			{productType && 
				<span style={{background: '#f8921d', padding: '5px 10px', color: 'white', borderBottom: '2px solid rgb(61, 61, 61)'}}>
					{productType.psdTemplateUrl &&
						<span><i className="fa fa-exclamation-circle" aria-hidden="true" /> Use <A href={productType.psdTemplateUrl} style={{textDecoration: 'underline', fontWeight: 'bold', color: '#3d3d3d'}}>{productType.label}.psd</A> to put your {artworkType.label} on a {productType.label}.</span>
					}
				</span>
			}
			
		</div>
		
		<Separator />
	</div>
};


const StepTwo = ({values, previewImage, productImages, onProductImgsUpdate}) =>{
	if(!values.productType || !values.artworkType) 
		return null;

	function onProductImgUpload(inputId) {
		const files = document.getElementById(inputId).files;

		var filesArr = [];
		for(var i = 0; i < files.length;i++)
			filesArr[i] = files[i];
		
		//the productImages state is read only
		var newProductImages = filesArr.concat(productImages);
		newProductImages.reverse();
		onProductImgsUpdate(newProductImages);
	}

	function clearProductImage(index) {
		//the productImages state is read only
		var newProductImages = productImages.concat([]);
		newProductImages.splice(index, 1);
		onProductImgsUpdate(newProductImages);
	}

	let imgConstraint = values.artworkType === ARTWORK_TYPES["PHOTOGRAPH"].val? PHOTOGRAPH_IMG_CONSTRAINT: DIGITAL_ART_IMG_CONSTRAINT;
	const productImgConstraintInfo = <span style={{fontSize: '70%', color: 'black'}}>({imgConstraint+", at least 1"})</span>;

	const productImagesPreview = productImages.map((img, i) => {
		var preview = <AddedImagePreview key={"productImage_"+i} id={"productImage_"+i} file={img} onRemove={() => clearProductImage(i)} />
		return preview;
	});

	const productUploaderSize = productImagesPreview? PRODUCT_IMAGES_LMT - productImagesPreview.length: PRODUCT_IMAGES_LMT;
	const productImgUploaders = [...Array(productUploaderSize).keys()].map(i => {
		const inputId = "productImageFile_"+i;
		return <ImgUploadForm inputId={inputId} key={inputId} onChange={() => onProductImgUpload(inputId)}/>
	});

	const productType = AppConstants.PRODUCT_TYPES[values.productType];
	
	let learnMore = null;
	if(productType === AppConstants.PRODUCT_TYPES.T_SHIRT)
		learnMore = <small style={{fontSize: '90%'}}><A href="/faq#tshirtDesignLimitation">Learn More!</A></small>
	else if (productType === AppConstants.PRODUCT_TYPES.HOODIES)
		learnMore = <small style={{fontSize: '90%'}}><A href="/faq#hoodiesDesignLimitation">Learn More!</A></small>

	return (
	<div>
		<div className="submitStep flexRow">
			<span>Step</span> <span className="stepCount">2</span>
		</div>

		<div id="designImgUploader" style={{minWidth: '100px', minHeight: '150px'}}>
			<div className="flexRow" style={{marginBottom: '20px'}}>
				<SelectedImagePreview id="designImagePreview" src={previewImage} />
			</div>
		</div>
		<div id="productImgUploader" style={{minWidth: '100px', minHeight: '150px'}}>
			<label>
				<span>Add {productType.label} Image: {learnMore}</span>
				{productImgConstraintInfo}
			</label>

			<div className="flexRow">
				{productImagesPreview &&
					<div className='flexRow'>
						{productImagesPreview}
					</div>
				}
				
				{
					productImgUploaders &&
					<div className="flexRow">
						{productImgUploaders}
					</div>
				}
				
			</div>
			<Input id="productImage" name="productImage" mui='off' type="hidden" />
		</div>
	</div>)
};


const StepThree = ({values, productTagOptions, isSubmitting}) => {
	if(!values.productType || !values.artworkType) 
		return null;

	let submitBtn = <span><i className="fa fa-cloud-upload" aria-hidden="true"></i> Submit</span>;
		
	if(isSubmitting === true)
		submitBtn = <span><i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i> Submitting</span>;
		
	return (
		<div>
			<div className="submitStep flexRow">
				<span>Step</span> <span className="stepCount">3</span>
			</div>

			<Input label="Title: " name="title" type="text" />

			<label style={{margin: '0 0 10px 0', display: 'block'}}>Select Tags or Enter new:</label>
			<ComboBox name="productTags" value={values.productTags} 
							options={productTagOptions} placeholder="Select Tags or Enter new (Optional)" 
							multi={true}
							closeOnSelect={true} 
							creatable={true} 
							/>

			<label style={{margin: '0 0 10px 0', display: 'block'}}>Description:</label>
			<TextArea placeholder={"Add a short info of your design (Optional)"}  name="description" rows="1" />

			<SubmitButton color="primary" disabled={isSubmitting}>{submitBtn}</SubmitButton>


			{values.artworkType === ARTWORK_TYPES.PHOTOGRAPH.val && 
				<div className="highlightInfo"><i className="fa fa-exclamation-circle" aria-hidden="true" /> You must also email your original photograph image at: <b>setocanvas@gmail.com</b>.</div>
			}

			{values.artworkType === ARTWORK_TYPES.DIGITAL_ART.val && 
				<div className="highlightInfo"><i className="fa fa-exclamation-circle" aria-hidden="true" /> You must also email a <b>300 resolution A4 size .png file (background less)</b> of your design at: <b>setocanvas@gmail.com</b>.</div>
			}
		</div>
	)
}

class SubmitSubProductForm extends React.Component {
	constructor(props) {
		super(props);

		this.validationScheme = this.validationScheme.bind(this);
		this.handleFormSubmission = this.handleFormSubmission.bind(this);
		this.INIT_VALUES = this.initializeValues();

		this.PRODUCT_IMAGES = [];

		this.state = {};
		this.handleOnProductImagesUpload = this.handleOnProductImagesUpload.bind(this);
	}

	initializeValues() {
		const product = this.props.product;
		let productType = '';

		//set photograph and frame by default for Photographer user
		return {title: product.title, description: product.description, artworkType: product.artworkType, productType: productType, 
						productImage: '', productTags: product.productTags || []
				}
	}

	clearUploadedFiles() {
		this.PRODUCT_IMAGES = [];
	}

	handleOnProductImagesUpload(productImages, setFieldValue) {
		this.PRODUCT_IMAGES = productImages;
		setFieldValue('productImage', productImages.length > 0? '1': '');//set a non-empty string to indicate the value has been set
	}

	validationScheme() {
		return Yup.object().shape({
			title: Yup.string().required("Enter a title that defines your design"),
			productType: Yup.string().required("Select a product type"),
			productTags: Yup.array().max(5, "Maximum 5 tags allowed"),
			productImage: Yup.string().required("Add product image with your design")
		});
	}

	handleFormSubmission(value, {setSubmitting, resetForm}) {
		const product = this.props.product;
		const selectedProductType = value.productType;

		const addSubProductRequest = {baseProductId:product.id, title: value.title, description: value.description, 
								productType: selectedProductType,
								productTags: value.productTags};
		
		HttpService.addSubProduct(addSubProductRequest, this.PRODUCT_IMAGES,
			function(success) {
					setSubmitting(false);
					if(!success) {
						return;
					}
					resetForm();
				});
	}


	render() {
		const productTagOptions = AppConstants.DEFAULT_PRODUCT_TAGS.map(function(v){
			return {'label': v.toUpperCase(), 'value': v.toLowerCase()}
		});
		
		const product = this.props.product;
		const productUrl = product? AppUtil.getProductURL(product): "#";
		return <div id="submitProductForm">
					<h3><A href={productUrl}>Go Back</A></h3>
					<Formik initialValues={this.INIT_VALUES} onSubmit={this.handleFormSubmission}
							validationSchema={this.validationScheme} 
							render={({values, setFieldValue, isSubmitting}) => {
						return (
								<RGForm>
									<StepOne values={values} baseProduct={product} />
								
									<StepTwo values={values} previewImage={product.previewImage} productImages={this.PRODUCT_IMAGES} 
										onProductImgsUpdate={(productImages) => {
										this.handleOnProductImagesUpload(productImages, setFieldValue);
									}}/>

									<StepThree values={values} productTagOptions={productTagOptions} isSubmitting={isSubmitting} />
								</RGForm>
						)}} />
			</div>
	}
}


export default Radium(SubmitSubProductForm);




// WEBPACK FOOTER //
// ./src/views/designer/SubmitSubProductForm.js